import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "./Component/TableComponent/Table";
import InputSearch from "./Component/Search/Search";
import PickColumn from "./Component/PickColumn/PickColumn";
import Action from "./Component/Action/Action";
import AddGroup from "./Component/AddGroup/AddGroup";
import CreatedOn from "./Component/CreatedOn/CreatedOn";
import Filter from "./Component/Filter/Filter";
import { osplist } from "./Component/Utils/Utils";

export default function All_Active_OSP_List() {
  const RowHeader = [
    "ID",
    "Status",
    "Company Name",
    "Email",
    "Assignes",
    "Phone Number",
    "Location",
    "Tags",
    "Actions",
  ];
  // const { rows, isLoading, error } = Usefetch_Get(
  //   "http://localhost:4000/Table"
  // );
  const path = "/admin-dashboard/view-osp/";

  return (
    <div>
      <Container>
        <Title>all osp</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={osplist}
              // isLoading={isLoading}
              // error={error}
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}
